import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { fields } from './data';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh',
  overflow: 'auto',
};

const GenerateReportSelectorModal = ({ handleClose, open, handleCloseModalSubmit }) => {
 

  const [selectedFields, setSelectedFields] = useState(
    fields.reduce((acc, field) => ({ ...acc, [field.id]: false }), {})
  );

  const handleFieldCheckboxChange = (fieldName, checked) => {
    setSelectedFields((prev) => ({
      ...prev,
      [fieldName]: checked,
    }));
  };

  const handleSelectAllChange = (checked) => {
    const newFieldsState = fields.reduce(
      (acc, field) => ({ ...acc, [field.id]: checked }),
      {}
    );
    setSelectedFields(newFieldsState);
  };

  const handleSubmit = () => {
    const isAnyFieldSelected = Object.values(selectedFields).some((value) => value === true);

    if (!isAnyFieldSelected) {
      return;
    }

    handleCloseModalSubmit(selectedFields); // Submit selected fields
    handleClose(); // Close modal
  };

  const truncateStyle = {
    whiteSpace: 'nowrap',
    width: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" sx={{ mb: 2 }} variant="h6" component="h2">
          Select Specific Fields To Export1
        </Typography>
        <Box gap={3} display="flex" sx={{ mb: "20px" }} alignItems="center">
          <Checkbox
            sx={{ padding: "0px" }}
            checked={Object.values(selectedFields).every((val) => val)}
            onChange={(e) => handleSelectAllChange(e.target.checked)}
          />
          <Typography id="modal-modal-title" variant="h6" component="h3">
            Select All
          </Typography>
        </Box>
        <FormGroup>
          {fields?.map((field, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={selectedFields[field.id]}
                  onChange={(e) =>
                    handleFieldCheckboxChange(field.id, e.target.checked)
                  }
                />
              }
              label={<Typography sx={truncateStyle}>{field.label}</Typography>}
            />
          ))}
        </FormGroup>
        <Grid my={2} item xs={12}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={handleClose}
            variant="outlined"
            fullWidth
          >
            Cancel
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

export default GenerateReportSelectorModal;
